import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import {
  setlocalChalanDetail,
  validateLocalChalanDetail,
} from "../../storeSlices/localChalanSlice";
import "./Chalan.css";
import LocalChalanRasid from "./LocalChalanRasid";
function LocalChalan() {
  //from local storage retreving eway data
  const jsonDataString = window.localStorage.getItem("jsonData");
  const ewayBillString = window.localStorage.getItem("ewayBillJson");

  const jsonData = JSON.parse(jsonDataString);
  const ewayBillData = JSON.parse(ewayBillString);

  const fromChalanDetail = useSelector(
    (state) => state.localChalanReducer.localChalan
  );
  // const [totalFright, SetFrieghtCalcu] = useState(0);
  const [details, setdetails] = useState({
    challan_no: fromChalanDetail.challan_number
      ? fromChalanDetail.challan_number
      : "",
    truck_no: fromChalanDetail.vehicle_number
      ? fromChalanDetail.vehicle_number
      : "",
    date: "",
    owner: "",
    phone: "",
    driver: fromChalanDetail.driver_name ? fromChalanDetail.driver_name : "",
    driver_mobile_number: "",
    driver_pan_no: "", //
    goodsLoadedFrom: "",
    goodsLoadedTo: "",
    Bookedby: "", //
    consignment: fromChalanDetail.entery_bill_no
      ? fromChalanDetail.entery_bill_no
      : "", // also used as bill of entry number till changes are made to backend as well
    cargo_freight: "",
    gr_no: fromChalanDetail.gr_no ? fromChalanDetail.gr_no : "",
    weight: fromChalanDetail.qty ? fromChalanDetail.qty : "",
    rate_per_unit: fromChalanDetail.rate ? fromChalanDetail.rate : "",
    total_freight: "",
    advance_amount: "",
    diesel: "",
    dieselQty: "",
    dieselPerLiter: "",
    petrol_pump_name: "",
    other_exp: 0,
    commission: 0,
    balance_freight: "",
  });

  // const [DieselCalcu, SetDieselCalcu] = useState(0);

  const [BalancefreightCalcu, SetBalanceFrieghtCalcu] = useState(0);
  // SetFrieghtCalcu(details?.weight * details?.rate_per_unit);
  // SetBalanceFrieghtCalcu(
  //   details.total_freight -
  //     (Number(details.advance_amount) +
  //       Number(details.other_exp) +
  //       Number(details.commission))
  // );

  // useEffect(() => {
  //   SetFrieghtCalcu(details?.weight * details?.rate_per_unit);
  // SetBalanceFrieghtCalcu(
  //   Number(details?.weight * details?.rate_per_unit) -
  //     (Number(details.advance_amount) +
  //       Number(details.other_exp) +
  //       Number(details.commission))
  // );
  //   // SetDieselCalcu(details?.dieselQty * details?.dieselPerLiter);
  // }, [details]);
  const dispatch = useDispatch();

  // to clear form button function

  const handleClearData = () => {
    setdetails({
      challan_no: "",
      truck_no: "",
      date: "",
      owner: "",
      phone: "",
      driver: "",
      driver_mobile_number: "",
      driver_pan_no: "", //
      goodsLoadedFrom: "",
      goodsLoadedTo: "",
      Bookedby: "", //
      consignment: "", //
      cargo_freight: "",
      gr_no: "",
      weight: "",
      rate_per_unit: "",
      total_freight: "",
      advance_amount: "",
      diesel: "",
      dieselQty: "",
      dieselPerLiter: "",
      petrol_pump_name: "",
      other_exp: 0,
      commission: 0,
      balance_freight: "",
    });
  };

  // retrive data from E-way form

  const handleRetrieveData = () => {
    if (jsonData || ewayBillData) {
      const retrievedFormData = {
        challan_no: fromChalanDetail.challan_number
          ? fromChalanDetail.challan_number
          : "",
        truck_no: ewayBillData?.vehicleNo || "",
        date: "",
        owner: "",
        phone: "",
        driver: "",
        driver_mobile_number: "",
        driver_pan_no: "", //
        goodsLoadedFrom: "",
        goodsLoadedTo: "",
        Bookedby: "", //
        consignment: "", //
        cargo_freight: "",
        gr_no: "",
        weight: ewayBillData?.quantity || "",
        rate_per_unit: ewayBillData?.rate || "",
        total_freight: "",
        advance_amount: "",
        diesel: "",
        dieselQty: "",
        dieselPerLiter: "",
        petrol_pump_name: "",
        other_exp: 0,
        commission: 0,
        balance_freight: "",
      };
      setdetails(retrievedFormData);
    }
  };

  const localChalan = useSelector(
    (state) => state.localChalanReducer.localChalan
  );

  const handleChange = (e) => {
    setdetails({ ...details, [e.target.name]: e.target.value });
  };

  // testing

  useEffect(() => {
    if (details.rate_per_unit !== "" && details.weight !== "") {
      const total = details?.weight * details?.rate_per_unit;
      setdetails((prevdetails) => ({
        ...prevdetails,
        total_freight: total,
      }));
    }
  }, [details.rate_per_unit, details.weight]);

  useEffect(() => {
    if (details.dieselQty !== "" && details.dieselPerLiter !== "") {
      const total_diesel = details?.dieselQty * details?.dieselPerLiter;
      setdetails((prevdetails) => ({
        ...prevdetails,
        diesel: total_diesel,
      }));
    }
  }, [details.dieselPerLiter, details.dieselQty]);

  useEffect(() => {
    if (
      details.total_freight !== "" &&
      details.advance_amount !== "" &&
      details.other_exp !== "" &&
      details.commission !== "" &&
      details.diesel !== ""
    ) {
      const balance =
        Number(details?.total_freight) -
        (Number(details?.advance_amount) +
          Number(details?.other_exp) +
          Number(details?.commission) +
          Number(details?.diesel));
      setdetails((prevdetails) => ({
        ...prevdetails,
        balance_freight: balance,
      }));
    }
  }, [
    details.total_freight,
    details.advance_amount,
    details.other_exp,
    details.commission,
    details.diesel,
  ]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    console.log(" localchallan details : ", details);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/localchallan/`,
      //` http://localhost:5000/localchallan/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
        },
        body: JSON.stringify(details),
      }
    );
    const json = await response.json();
    console.log("local challan --=>", json);

    // first validate chalan details
    dispatch(validateLocalChalanDetail(details));

    // set chalan details
    dispatch(setlocalChalanDetail(details));

    document.getElementById("bill-form").classList.toggle("c-form");
    document.getElementById("bill-template").classList.toggle("bill");
  };

  return (
    <div className="local-chalan-form">
      <form className="chalan-form" onSubmit={handleSubmit} id="bill-form">
        <Button
          type="button"
          style={{
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
          onClick={handleClearData}
        >
          Clear Form
        </Button>
        {"  "}
        <Button
          type="button"
          style={{
            border: "2px solid #ccc",
            fontSize: "18px",
            padding: "8px 16px",
          }}
          onClick={handleRetrieveData}
        >
          Retrieve Data
        </Button>
        <label style={{ marginTop: "10px" }}>
          Challan Number:
          <input
            type="text"
            name="challan_no"
            value={details.challan_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Vehicle No:
          <input
            type="text"
            name="truck_no"
            value={details.truck_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Date:
          <input
            type="date"
            name="date"
            value={details.date}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Owner Name And Address:
          <input
            type="text"
            name="owner"
            value={details.owner}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Owner Mobile Number:
          <input
            type="number"
            name="phone"
            value={details.phone}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Driver Name:
          <input
            type="text"
            name="driver"
            value={details.driver}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Driver Pan Number:
          <input
            type="text"
            name="driver_pan_no"
            value={details.driver_pan_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Driver Mobile Number:
          <input
            type="number"
            name="driver_mobile_number"
            value={details.driver_mobile_number}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          GR Number:
          <input
            type="text"
            name="gr_no"
            value={details.gr_no}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Goods Loaded From:
          <input
            type="text"
            name="goodsLoadedFrom"
            value={details.goodsLoadedFrom}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Goods Loaded To:
          <input
            type="text"
            name="goodsLoadedTo"
            value={details.goodsLoadedTo}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Booked By:
          <input
            type="text"
            name="Bookedby"
            value={details.Bookedby}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Bill of entry number:
          <input
            type="text"
            name="consignment"
            value={details.consignment}
            onChange={handleChange}
          />
        </label>
        <br />
        {/* <label>
          Cargo freight:
          <input
            type="number"
            name="cargo_freight"
            value={details.cargo_freight}
            onChange={handleChange}
          />
        </label>
        <br /> */}
        <label>
          Weight:
          <input
            type="number"
            name="weight"
            value={details.weight}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Rate Per Unit:
          <input
            type="number"
            name="rate_per_unit"
            value={details.rate_per_unit}
            // onChange={handleChange}
            onChange={(event) => {
              handleChange(event);
            }}
          />
        </label>
        <br />
        <label>
          Total Freight : {details?.weight * details?.rate_per_unit}
          <input
            type="number"
            name="total_freight"
            value={details.total_freight}
            onChange={handleChange}
            placeholder="write manually "
          />
        </label>
        <br />
        <label>
          Advanced Freight:
          <input
            type="number"
            name="advance_amount"
            value={details.advance_amount}
            onChange={handleChange}
          />
        </label>
        <br />

        <label>
          diesel ( rate per liter ):
          <input
            type="text"
            name="dieselPerLiter"
            value={details.dieselPerLiter}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          diesel (qty ):
          <input
            type="text"
            name="dieselQty"
            value={details.dieselQty}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          diesel (Rs): {details?.dieselQty * details?.dieselPerLiter}
          <input
            type="text"
            name="diesel"
            value={details.diesel}
            onChange={handleChange}
            placeholder="write manually "
          />
        </label>
        <br />
        <label>
          Other Exp:
          <input
            type="number"
            name="other_exp"
            value={details.other_exp}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          commission:
          <input
            type="number"
            name="commission"
            value={details.commission}
            onChange={handleChange}
          />
        </label>
        <br />
        <label>
          Petrol Pump Name:
          <input
            type="text"
            name="petrol_pump_name"
            value={details.petrol_pump_name}
            onChange={handleChange}
          />
        </label>
        <br />
        {/* <label>Balance Freight:{BalancefreightCalcu}</label> */}
        <label>
          Balance Freight:{" "}
          {Number(details?.weight * details?.rate_per_unit) -
            (Number(details.advance_amount) +
              Number(details.other_exp) +
              Number(details.commission) +
              Number(details.diesel))}
          <input
            type="number"
            name="balance_freight"
            // value={
            //   (details.balance_freight =
            //     details.total_freight -
            //     (Number(details.advance_amount) +
            //       Number(details.other_exp) +
            //       Number(details.commission)))
            // }
            // value={details.balance_freight}
            value={details.balance_freight}
            onChange={handleChange}
            placeholder="write manually "
          />
        </label>
        <br />
        <input
          className="generate"
          type="submit"
          value="Generate Local Chalan"
        />
      </form>

      {/* bill template */}
      <LocalChalanRasid localChalan={localChalan} />
    </div>
  );
}

export default LocalChalan;
